(function() {
    window.c24.lp.ac.av = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('av');

            $('.mod24ac.av .logo').on('click', function(event) {
                event.preventDefault();
                $(this).closest('form').submit();
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.av.init();
    });
})();
